import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSchedulePerformancePage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useSchedulePerformanceSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getSchedulePerformanceSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.schedule_performance_page?.schedule_performance_section}`);
      console.log("🚀 ~ getSchedulePerformanceSectionJson ~ data:", response);
      console.log("🚀 ~ getSchedulePerformanceSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setSchedulePerformancePage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Schedule Performance section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getSchedulePerformanceSectionJson();
  }, [getSchedulePerformanceSectionJson]);

  return {
    data,
    loading,
    error,
    getSchedulePerformanceSectionJson,
    fetchOnMount,
    refetch: getSchedulePerformanceSectionJson
  };
};

export default useSchedulePerformanceSection;
